module.exports = __webpack_public_path__ + "img/Frame 427322912.52a801a3.png";